import Model from '@/Models/Contracts/Model';
import BudgetEntry from '@/Models/BudgetEntry';
import Store from '@/Models/Store';
import Review from '@/Models/Review';
export default class Budget extends Model {
    resource() {
        return 'budgets';
    }
    relations() {
        return {
            store: Store,
            entries: BudgetEntry,
            reviews: Review,
        };
    }
    relationships() {
        return {
            'store': this.hasMany(Store),
            'entries': this.hasMany(BudgetEntry),
        };
    }
}
